import { Injectable } from '@angular/core';
import { ModalContent } from '@src/shared/modal/confirm-modal/confirm-modal.type';
import { ModalService } from '@src/shared/modal/modal.service';
import { AdHocContract, AdHocContractParams, AdHocContractService } from './AdHocContractService';
import { TranslationService } from './TranslationService';
import { VoucherParams, VoucherService } from './VoucherService';
import { Voucher, wooId } from './shared-types';

@Injectable({ providedIn: 'root' })
export class DiscountsInteractionService {
  readonly confirmRemoveContent: ModalContent = {
    title: 'Ta bort rabatt',
    texts: ['Är du säker på att du vill ta bort rabatten?'],
    confirmLabel: 'Ja, fortsätt',
    cancelLabel: 'Nej, avbryt',
  };

  readonly confirmCreateContent: ModalContent = {
    title: 'Ny rabatt',
    texts: ['Är du säker på att du vill lägga till den nya rabatten?'],
    confirmLabel: 'Ja, fortsätt',
    cancelLabel: 'Nej, avbryt',
  };

  constructor(
    private modalService: ModalService,
    private voucherService: VoucherService,
    private adHocContractService: AdHocContractService,
    private translationService: TranslationService,
  ) {}

  //TODO Redo implementation
  deleteVoucher = async (voucherId: wooId): Promise<Voucher> => {
    return this.voucherService
      .deleteVoucher(voucherId)
      .then((voucher: Voucher) => {
        this.modalService.openSuccess('Wooho! Det där gick ju bra.', 'Rabatten är nu borttagen.');
        return voucher;
      })
      .catch((err) => {
        this.modalService.openError(
          'Kunde inte ta bort rabatt.',
          this.translationService.convertError(err.error.error),
        );
        return null;
      });
  };

  createVoucher = async (newVoucher: VoucherParams, customerId: wooId): Promise<Voucher | null> => {
    const response = await this.modalService.openConfirm(this.confirmCreateContent);

    if (!response.confirm) {
      return null;
    }

    return this.voucherService
      .createVoucher(customerId, newVoucher)
      .then((voucher: Voucher) => {
        this.modalService.openSuccess('Wooho! Det där gick ju bra.', 'Rabatten är nu tillagd.');
        return voucher;
      })
      .catch((err) => {
        this.modalService.openError('Kunde inte skapa rabatt.', this.translationService.convertError(err.error.error));
        return null;
      });
  };

  deleteAdHocContract = async (contractId: wooId): Promise<AdHocContract> => {
    return this.adHocContractService.deleteAdHocContract(contractId);
  };

  createAdHocContract = async (newContract: AdHocContractParams, customerId: wooId): Promise<AdHocContract | null> => {
    const value = await this.modalService.openConfirm(this.confirmCreateContent);
    if (value.confirm) {
      const contract = await this.adHocContractService.createAdHocContract(customerId, newContract);
      this.modalService.openSuccess('Wooho! Det där gick ju bra.', 'Ad Hoc-rabatten är nu tillagd.');
      return contract;
    }
    return null;
  };
}
